import { CidadeService } from 'itbi-common/service';

import * as CidadeActions from './actions';

export const getCidadeLogada = () => dispatch => {
  return CidadeService.getCidadeLogada().then(response =>
    dispatch(CidadeActions.getCidadeLogadaSuccess(response.data))
  );
};
